import { Dropdown } from "react-bootstrap";
import useDropdown from "../../hooks/dropdown.hook";
import { useState } from "react";
import { TrimString } from "../../Utils/StringTrimmer";
import { HGHighlightText } from "../App/App";

const CustomHGDropdown = ({
  fieldId,
  fieldValue,
  selected,
  onClick,
  data = [],
  placeholder = "Select",
  placeholderClass,
  selectedItemClass,
  greyBackground,
  dropDownMenuClass,
  selectedColorBlack,
  dropDownToggleClass,
  placeDropDownAtTopRight,
  dataLoading,
  question,
  disabled,
  minWidth,
  selectedTextTrimLength,
  maxContentWidth,
  showSearch,
  prefix,
  contentwidth,
  putMenuAtRight,
  redBorder,
  pluralCheck,
  alignRight,
  className
}) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({});
  const [searchString, setSearchString] = useState("");
  const dropdownToggleRef = refBtn;
  let selectedValue = selected?.[fieldValue];
  if (pluralCheck && selectedValue && selectedValue[selectedValue.length - 1] === "s") {
    selectedValue = selectedValue.slice(0, -1);
  }
  return (
    <Dropdown
      show={isOpen}
      onToggle={() => {
        setIsOpen(prev => !prev);
      }}
      className={`transparennt-wrapper-dropdown my-dropdown ${className}`}
      alignRight={alignRight}
    >
      <Dropdown.Toggle
        ref={dropdownToggleRef}
        className={`p-0 ${greyBackground ? "bg-grey-imp" : ""
          }   ${dropDownToggleClass}  ${redBorder ? "input-error" : ""} `}
      >
        <div className="d-flex align-items-center  f-500 f-grey  px-2 p-2 w-100">
          {selected ? (
            <span
              className={`${selectedItemClass ?? ""} ${selectedColorBlack ? "f-black" : "f-grey"
                } f-500`}
            >
              {prefix && <span className="f-grey-imp">{prefix}: </span>}{" "}
              {TrimString(selectedValue, selectedTextTrimLength ?? 40)}{" "}
            </span>
          ) : (
            <span className={`${placeholderClass ?? " f-darkgrey "}  `}>
              {prefix && <span className="f-grey-imp">{prefix}: </span>}{" "}
              {placeholder}{" "}
            </span>
          )}

          {!disabled && (
            <img
              src="/images/big-chevron-down.svg"
              alt=""
              className={placeDropDownAtTopRight ? "ml-auto" : "ml-2"}
            />
          )}
        </div>
      </Dropdown.Toggle>
      {!disabled && (
        <Dropdown.Menu
          ref={refMenu}
          className={`${dropDownMenuClass}  p-1 ${putMenuAtRight && "menu-inset-right-corner"
            }`}
          style={{
            // width: "200px",
            minWidth: minWidth ?? undefined,
          }}
          renderOnMount
          popperConfig={{strategy: "fixed"}}
          align={'right'}
        >
          {dataLoading ? (
            <div
              className="d-flex align-items-center justify-content-center w-100 "
              style={{
                height: "250px",
              }}
            >
              
            </div>
          ) : (
            <>
              {question && (
                <div className="f-12 f-400 f-darkgrey mb-2">{question}</div>
              )}
              {showSearch && (
                <div className="d-flex align-items-center px-2 py-2 radius-4 mb-1"
                  style={{
                    border: "1px solid #c8c8c8"
                  }}

                >
                  <img
                    src="/images/attack-surface/search-icon.svg"
                    className="mr-1"
                    alt=""
                  />
                  <input
                    type="text"
                    className="flex-1 bg-transparent border-none pl-1"
                    placeholder="Search"
                    value={searchString}
                    onChange={(e) => {
                      setSearchString(e.target.value);
                    }}
                    autoFocus
                  />
                  <img
                    src="/images/settings-v2/header-search-cross.svg"
                    alt=""
                    className="mx-1 pointer"
                    style={{
                      visibility: searchString ? "visible" : "hidden",
                    }}
                    onClick={() => {
                      setSearchString("");
                    }}
                  />
                </div>
              )}

              {data?.filter((item) =>
                item?.[fieldValue]
                  ?.toLowerCase()
                  ?.includes(searchString?.toLowerCase())
              )?.length === 0 && (
                  <div className="my-2 f-darkgrey w-100 pl-4">No data found</div>
                )}
              <div
                className="transparent-scroller w-100"
                style={{
                  maxHeight: "250px",
                  overflowY: "auto",
                  width: contentwidth ?? "max-content",
                  maxWidth: maxContentWidth ?? "200px",
                }}
              >
                {data
                  ?.filter((item) =>
                    item?.[fieldValue]
                      ?.toLowerCase()
                      ?.includes(searchString?.toLowerCase())
                  )
                  ?.map((item, index) => {
                    let selectedItem = item?.[fieldValue];
                    if (pluralCheck && selectedItem && selectedItem[selectedItem.length - 1] === "s") {
                      selectedItem = selectedItem.slice(0, -1);
                    }
                    return (
                      <div
                        className="d-flex align-items-center f-500 f-grey pointer radius-4 bg-hover-little-grey w-100"
                        style={{
                          padding: "0.4rem"
                        }}
                        onClick={(e) => {
                          onClick(item[fieldId], item[fieldValue], item);
                          if (dropdownToggleRef.current) {
                            dropdownToggleRef.current.click();
                          }
                          // e.target
                          //   .closest(".transparennt-wrapper-dropdown")
                          //   .click();
                        }}
                      >
                        <img
                          src="/images/msp/dropdown-grey-tick.svg"
                          alt=""
                          className="mr-2"
                          style={{
                            visibility:
                              selected && selected[fieldId] === item[fieldId]
                                ? "visible"
                                : "hidden",
                          }}
                        />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: HGHighlightText(
                              selectedItem,
                              searchString
                            ),
                          }}
                        />

                      </div>
                    );
                  })}
              </div>
            </>
          )}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default CustomHGDropdown;
